/* Accordion buttons */

$('body').on('hidden.bs.collapse', '.collapse', function () {
  var id = $(this).closest('.accordion').attr('id')
  $('.expandAll[data-target="#' + id + '"]').removeClass('disabled')

  if ($(this).closest('.accordion').find('.collapse.show').length === 0) {
    $('.collapseAll[data-target="#' + id + '"]').addClass('disabled')
  }
})

$('body').on('shown.bs.collapse', '.collapse', function () {
  var id = $(this).closest('.accordion').attr('id')
  $('.collapseAll[data-target="#' + id + '"]').removeClass('disabled')

  if ($(this).closest('.accordion').find('.collapse:not(.show)').length === 0) {
    $('.expandAll[data-target="#' + id + '"]').addClass('disabled')
  }
})

$('body').on('click', '.expandAll', function () {
  var id = $(this).attr('data-target')
  $(this).addClass('disabled')

  $('.collapseAll[data-target="' + id + '"]').removeClass('disabled')

  $(id + ' .collapse').collapse('show')
})

$('body').on('click', '.collapseAll', function () {
  var id = $(this).attr('data-target')
  $(this).addClass('disabled')

  $('.expandAll[data-target="' + id + '"]').removeClass('disabled')

  $(id + ' .collapse').collapse('hide')
})
